var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.type==='insights')?_c('InsightsTemplate'):(_vm.type==='dashboard-access')?_c('DashboardAccessLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }